import { createApp, ref } from "vue";
import { createBottomSheet } from "bottom-sheet-vue3";
import "bottom-sheet-vue3/style.css";
import App from "./App.vue";
import router from "./router";
import helper from "@/utils/helper";
import store from "./store";
import "./assets/main.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import bottomNavigationVue from "bottom-navigation-vue";
import "./registerServiceWorker";
//import "leaflet/dist/leaflet.css";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCircleInfo,
  faLocationDot,
  faPassport,
  faSquarePhoneFlip,
  faShop,
  faMoneyCheckDollar,
  faCircleUser,
  faListCheck,
  faCircleXmark,
  faCircleCheck,
  faCalendarDays,
  faChartColumn,
  faCartShopping,
  faRightFromBracket,
  faCircleExclamation,
  faXmark,
  faFilterCircleXmark,
  faHashtag,
  faArrowsRotate,
  faMoneyBill,
  faMoneyCheck,
  faCreditCard,
  faMobileScreenButton,
  faMagnifyingGlass,
  faUserPlus,
  faIdBadge,
  faPlus,
  faPenToSquare,
  faCheck,
  faIdCard,
  faTruckMoving,
  faListOl,
  faReceipt,
  faSackDollar,
  faMapLocationDot,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faCircleInfo,
  faLocationDot,
  faPassport,
  faMoneyCheckDollar,
  faSquarePhoneFlip,
  faShop,
  faCircleUser,
  faListCheck,
  faCircleXmark,
  faCircleCheck,
  faCalendarDays,
  faChartColumn,
  faCartShopping,
  faRightFromBracket,
  faCircleExclamation,
  faXmark,
  faFilterCircleXmark,
  faHashtag,
  faArrowsRotate,
  faMoneyBill,
  faMoneyCheck,
  faCreditCard,
  faMobileScreenButton,
  faMagnifyingGlass,
  faUserPlus,
  faIdBadge,
  faPlus,
  faPenToSquare,
  faCheck,
  faIdCard,
  faTruckMoving,
  faListOl,
  faReceipt,
  faSackDollar,
  faMapLocationDot
);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./registerServiceWorker";

const app = createApp(App);
app.config.globalProperties.$loading = ref(false);
//app.config.globalProperties.$customer = ref(false);

app
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(VueSweetalert2)
  .use(createBottomSheet())
  .use(bottomNavigationVue)
  .use(router)
  .use(store)
  .use(helper)
  .use(Vue3PersianDatetimePicker, {
    name: "CustomDatePicker",
    props: {
      format: "jYYYY/jMM/jDD",
      displayFormat: "jYYYY/jMM/jDD",
      editable: false,
      inputClass: "datepicker",
      placeholder: "لطفا یک تاریخ انتخاب کنید",
      altFormat: "YYYY/MM/DD",
      color: "oklch(79.5% 0.184 86.047)",
      autoSubmit: false,
    },
  })
  .mount("#app");

export default app;
